import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  Col,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
  Steps,
  Flex,
  Button,
} from "antd";
import { useNavigate, Link } from "react-router-dom";

//PROJECT IMPORTS
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import CustomButton from "../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import definedApi from "../../../services/definedApi";
import { newGlAccountAction } from "../../../redux/actions";
import { staticConfig } from "../glAndAccounting.config";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
import styles from "../../../assets/styles/styles";
import OverviewForm from "./components/add/Overview";
import CurrencyConfigurationForm from "./components/add/CurrencyConfiguration";
import PostingControlsForm from "./components/add/PostingControls";
import BalanceManagement from "./components/add/BalanceManagement";
import ReconcilationAndControlForm from "./components/add/ReconcilationAndControl";
import Preview from "./components/add/Preview";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const AddGLA0100Demo = (props) => {
  const [form] = Form.useForm();
  //DECLARED VARIABLES
  const {
    userData,
    onSelectItemAction,
    rightBtn,
    rightAction,
    getGlListAction,
    newGlAccountAction,
  } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newGLItems, statusData } = appStatic;

  const [accountTypeData, setAccountTypeData] = useState([]);
  const [parentData, setParentData] = useState([]);
  const [accountUsageData, setAccountUsageData] = useState([]);
  const [accountTagData, setAccountTagData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [manualEntriesAllowed, setManualEntriesAllowed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [glAccTemplate, setGlAccTemplate] = useState({});
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [glCodeLengthLoading, setGlCodeLengthLoading] = useState(false);
  const [glCodeLength, setGlCodeLength] = useState(1);
  const [current, setCurrent] = useState(0);
  const [formData, setFormData] = useState({});
  const steps = [
    "GL Overview",
    "Currency Configuration",
    "Posting Controls",
    "Balance Management",
    "Reconciliation and Control",
    "Preview",
  ];
  const isLastStep = current === steps.length - 1;

  const nextButtonClick = () => {
    form.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };
  // Watch the account type field for changes
  const selectedAccountType = Form.useWatch("type", form);
  console.log(selectedAccountType, glAccTemplate, "selectedAccountType");
  useEffect(() => {
    getTemplate();
    getGlcodeLength();
  }, []);

  // Effect to handle account type changes and update parent/tag data
  useEffect(() => {
    if (selectedAccountType && glAccTemplate) {
      updateParentAndTagData(selectedAccountType);
      // Clear the parent and tag fields when account type changes
      form.setFieldsValue({
        parentId: undefined,
        tagId: undefined,
      });
    }
  }, [selectedAccountType, glAccTemplate]);

  const updateParentAndTagData = (accountTypeId) => {
    // Find the account type option to get its label
    console.log(accountTypeData, accountTypeId, "accountTypeData");
    const accountTypeOption = accountTypeData.find((option) => option.value === accountTypeId);
    console.log(accountTypeOption, "accountTypeOption");
    if (!accountTypeOption) return;

    const accountTypeLabel = accountTypeOption.label.toLowerCase();

    let parentOptions = [];
    let tagOptions = [];

    console.log(accountTypeLabel, "accountTypeLabel");

    switch (accountTypeLabel) {
      case "asset":
        parentOptions = getOptionsFromTemplate("assetHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedAssetsTagOptions");
        break;

      case "liability":
        parentOptions = getOptionsFromTemplate("liabilityHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedLiabilitiesTagOptions");
        break;

      case "equity":
        parentOptions = getOptionsFromTemplate("equityHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedEquityTagOptions");
        break;

      case "expense":
        parentOptions = getOptionsFromTemplate("expenseHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedExpensesTagOptions");
        break;

      case "income":
        parentOptions = getOptionsFromTemplate("incomeHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedIncomeTagOptions");
        break;

      case "contingent_asset":
        parentOptions = getOptionsFromTemplate("contingentAssetHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedContingentAssetsTagOptions");
        break;

      case "contingent_liability":
        parentOptions = getOptionsFromTemplate("contingentLiabilityHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedContingentLiabilitiesTagOptions");
        break;

      default:
        parentOptions = getOptionsFromTemplate("assetHeaderAccountOptions");
        tagOptions = getOptionsFromTemplate("allowedAssetsTagOptions");
        break;
    }
    console.log(parentOptions, "parentOptions");

    setParentData(parentOptions);
    setAccountTagData(tagOptions);
  };

  const getOptionsFromTemplate = (templateKey) => {
    if (!glAccTemplate[templateKey]) return [];

    return glAccTemplate[templateKey].map((element) => ({
      value: element.id,
      label: element.name,
    }));
  };

  function onCancel() {
    navigate("/gla0100", { replace: false });
  }

  function getTemplate() {
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, definedApi.GlAccountTemplate, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        console.log(res, "res");
        const objList = res;

        // TODO
        const mockTemplate = {
          accountLevelOptions: [
            {
              id: 1,
              value: "Level 1",
            },
            {
              id: 2,
              value: "Level 2",
            },
          ],
          accountStatusOptions: [
            {
              id: 1,
              value: "Active",
            },
            {
              id: 2,
              value: "Inactive",
            },
          ],
          naturalBalanceOptions: [
            {
              id: 1,
              value: "Debit",
            },
            {
              id: 2,
              value: "Credit",
            },
          ],
          ifrsClassificationOptions: [
            {
              id: 1,
              value: "IFRS 1",
            },
            {
              id: 2,
              value: "IFRS 2",
            },
          ],
          taxCategoryOptions: [
            {
              id: 1,
              value: "Tax Category 1",
            },
          ],
          currenyCodeOptions: [
            {
              id: 1,
              value: "USD",
            },
            {
              id: 2,
              value: "EUR",
            },
            {
              id: 3,
              value: "GBP",
            },
            {
              id: 4,
              value: "NGN",
            },
          ],
          yesOrNo: [
            { value: true, label: "Yes" },
            { value: false, label: "No" },
          ],
          revaluationGlAccountOptions: [
            { value: "1001", label: "1001 - Revaluation Gains" },
            { value: "2001", label: "2001 - Revaluation Losses" },
            { value: "3001", label: "3001 - FX Revaluation" },
          ],
          controlAccountFlagOptions: [
            { value: "primary", label: "Primary" },
            { value: "secondary", label: "Secondary" },
            { value: "suspense", label: "Suspense" },
          ],
          externalSettlementAccount: [
            { value: "1001", label: "1001 - External Settlement Account" },
            { value: "2001", label: "2001 - External Settlement Account" },
            { value: "3001", label: "3001 - External Settlement Account" },
          ],
        };

        setGlAccTemplate({ ...res, ...mockTemplate });
        let tempAccountType = [];
        let tempAccountUsage = [];
        let tempCurrency = [];

        objList?.accountTypeOptions?.forEach((element) => {
          tempAccountType.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.usageOptions?.forEach((element) => {
          tempAccountUsage.push({
            value: element.id,
            label: element.value,
          });
        });

        // Add "All" option first, then add other currencies
        tempCurrency.push({
          value: "ALL",
          label: "All Currencies",
        });

        objList?.currencies?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });

        // Set default account type
        // if (
        //   objList?.accountTypeOptions &&
        //   objList.accountTypeOptions.length > 0
        // ) {

        // }

        form.setFieldsValue({
          type: objList.accountTypeOptions[0].id,
          manualEntriesAllowed: staticConfig.yesOrNo[0].value,
          status: statusData[0].value,
          usage: tempAccountUsage[0].value,
          currencyCode: tempCurrency[1].value,
        });

        setAccountTypeData(tempAccountType);
        setAccountUsageData(tempAccountUsage);
        setCurrencyData(tempCurrency);
        setIsLoading(false);
      }
    });
  }

  function getGlcodeLength() {
    setGlCodeLengthLoading(true);
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GlAccountCodeLengthConfig, (err, res) => {
      setGlCodeLengthLoading(false);
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        console.log(res);
        setGlCodeLength(res?.value ?? 0);
      }
    });
  }
  // Add this handler function for currency change
  const handleCurrencyChange = (value) => {
    setSelectedCurrency(value);
  };

  const handleManuelEntriesAllowed = (e) => {
    setManualEntriesAllowed(e.target.checked);
  };

  const onSubmit = (formValues) => {
    // formValues.manualEntriesAllowed = manualEntriesAllowed;

    // Remove currencyCode from payload if "All" is selected
    if (selectedCurrency === "ALL" || formValues.currencyCode === "ALL") {
      delete formValues.currencyCode;
    }

    const body = {
      ...formValues,
      method: "POST",
      session,
    };

    // console.log(body)
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      definedApi.NewGlAccount,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, appLabel.newGLCreatedMsg);
          navigate("/gla0100");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/gla0100");
          setIsLoading(false);
        },
      },
    );
  };

  const onFinishOverviewForm = (values) => {
    console.log(values, "values");
    setFormData({ ...formData, overview: values });
    setCurrent(current + 1);
  };

  const onFinishCurrencyConfigurationForm = (values) => {
    setFormData({ ...formData, currencyConfiguration: values });
    setCurrent(current + 1);
  };

  const onFinishPostingControlsForm = (values) => {
    setFormData({ ...formData, postingControls: values });
    setCurrent(current + 1);
  };

  const onFinishBalanceManagementForm = (values) => {
    setFormData({ ...formData, balanceManagement: values });
    setCurrent(current + 1);
  };

  const onFinishReconcilationAndControlForm = (values) => {
    setFormData({ ...formData, reconcilationAndControl: values });
    setCurrent(current + 1);
  };

  const forms = [
    <OverviewForm
      templateData={glAccTemplate}
      parentData={parentData}
      accountTypeData={accountTypeData}
      tagData={accountTagData}
      glCodeLength={glCodeLength}
      form={form}
      onFinish={onFinishOverviewForm}
      formData={formData.overview}
    />,
    <CurrencyConfigurationForm
      templateData={glAccTemplate}
      form={form}
      onFinish={onFinishCurrencyConfigurationForm}
      formData={form}
    />,
    <PostingControlsForm
      templateData={glAccTemplate}
      form={form}
      onFinish={onFinishPostingControlsForm}
      formData={form}
    />,
    <BalanceManagement
      templateData={glAccTemplate}
      form={form}
      onFinish={onFinishBalanceManagementForm}
      formData={form}
    />,

    <ReconcilationAndControlForm
      templateData={glAccTemplate}
      form={form}
      onFinish={onFinishReconcilationAndControlForm}
      formData={form}
    />,
    <Preview
      formData={formData}
      templateProdDetail={glAccTemplate}
      parentOptions={parentData}
      // chargeTableSource={chargeTableSource}
      // configureFundTableSource={configureFundTableSource}
      // mapFeeTableSource={mapFeeTableSource}
      // mapPenaltyTableSource={mapPenaltyTableSource}
      // showAdvancedAccounting={showAdvancedAccounting}
    />,
  ];

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit} currentStep={steps[current]}>
      <TopContent pageTitle={appLabel.generalLedger} pageItems={staticConfig.newGLItems} />
      <Spin spinning={isLoading} tip="Loading..." size="large">
        <Card title={appLabel.generalLedger} style={styles.cardWrapper}>
          <div>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
              style={{ marginBottom: 25 }}
            >
              <Col span={24}>
                <Row style={{ justifyContent: "space-between" }}>
                  <Card style={styles.cardSteps}>
                    <Steps
                      current={current}
                      onChange={setCurrent}
                      direction="vertical"
                      style={{ height: "600px" }}
                      items={[
                        {
                          title: <Text strong>GL Overview</Text>,
                        },
                        {
                          title: <Text strong>Currency Configuration</Text>,
                        },
                        {
                          title: <Text strong>Posting Controls</Text>,
                        },
                        {
                          title: <Text strong>Balance Management</Text>,
                        },
                        {
                          title: <Text strong>Reconciliation and Control</Text>,
                        },
                        {
                          title: <Text strong>Preview</Text>,
                        },
                      ]}
                    />
                  </Card>
                  {/* Form Section */}
                  <Card style={styles.cardStepDisplay}>
                    <div>{forms[current]}</div>
                    {/* </Form> */}
                  </Card>
                </Row>
              </Col>
            </Row>

            {/* Submitt section */}
            <Card
              style={{
                marginBottom: 25,
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
                padding: 5,
              }}
            >
              <Flex justify="space-between" style={{ paddingLeft: "20px", paddingRight: "40px" }}>
                {current === 0 && (
                  <Button
                    style={{
                      width: "12%",
                      height: "15%",
                      backgroundColor: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                      color: "black",
                    }}
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#92428B",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={prevButtonClick}
                  >
                    Previous
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#92428B",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={nextButtonClick}
                  >
                    Next
                  </Button>
                )}
                {BOM.HasPermission("CREATE_SAVINGSPRODUCT") && isLastStep && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={onSubmit}
                    backgroundColor="#fff"
                    colorText="black"
                    hoverBackground="#F5F5F5"
                  />
                )}
              </Flex>
            </Card>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { newGlAccountAction };

export default connect(mapStateToProps, mapDispatchToProps)(AddGLA0100Demo);
